import React from "react";
import {
  ResponsiveContainer,
  AreaChart,
  Area,
  XAxis,
  Tooltip,
  CartesianGrid
} from "recharts";

const NetSalesAreaChart = ({ data }) => (
  <ResponsiveContainer width="100%" height={260}>
    <AreaChart data={data}>
      <defs>
        <linearGradient id="netSalesGradient" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#1b014d" stopOpacity={0.8} />
          <stop offset="100%" stopColor="#1b014d" stopOpacity={0.1} />
        </linearGradient>
      </defs>

      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="time" />
      <Tooltip />
      <Area
        type="monotone"
        dataKey="net_sales"
        stroke="#1b014d"
        strokeWidth={3}
        fill="url(#netSalesGradient)"
      />
    </AreaChart>
  </ResponsiveContainer>
);

export default NetSalesAreaChart;
